var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.262 7.018a.5.5 0 0 1 0-.636L5.052.574a.5.5 0 0 1 .885.318V3c0 .276.23.5.507.507 7.142.187 9.624 4.356 10.322 8.21.104.574-.9.787-1.328.39-1.29-1.196-3.815-2.146-8.993-2.204a.502.502 0 0 0-.508.497v2.108a.5.5 0 0 1-.885.318L.262 7.018Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidBackArrow);
export default __webpack_public_path__ + "static/media/solid-back-arrow.7bff67f975948d5c2c8e3cca1e290a31.svg";
export { ForwardRef as ReactComponent };